import { useTheme } from "arkh";
import React from "react";
import { useIntl } from "react-intl";
import { Platform } from "react-native";
import { HeaderButton } from "../../../components";
import { useIntlTokens } from "../../../components/mobile/useIntlTokens";
import { UserLoggedInNavigatorScreenProps } from "../../../TopLevelNavigators/UserLoggedIn/UserLoggedInNavigatorParamList";
import { KPICreateSubTeamStack } from "./KPICreateSubTeamStack";
import { KPICreateSubTeamSelectTeam } from "./KPICreateSubTeamSelectTeam";
import { KPICreateSubTeamSetName } from "./KPICreateSubTeamSetName";
import { withWebModal } from "@/src/TopLevelNavigators/UserLoggedIn/withWebModal";
export const KPICreateSubTeam = withWebModal(KPICreateSubTeamC);
function KPICreateSubTeamC(
  props: UserLoggedInNavigatorScreenProps<"KPICreateSubTeam">
) {
  const intl = useIntl();
  const intl_tokens = useIntlTokens();
  const theme = useTheme();
  return (
    <KPICreateSubTeamStack.Navigator
      screenOptions={{
        headerStyle: {
          backgroundColor: theme.background,
        },
      }}
    >
      <KPICreateSubTeamStack.Screen
        name="KPICreateSubTeamSelectTeam"
        component={KPICreateSubTeamSelectTeam}
        options={({ navigation }) => ({
          headerLeft:
            Platform.OS === "ios"
              ? () => <HeaderButton type="CANCEL" onPress={navigation.goBack} />
              : undefined,
          title: intl.formatMessage({
            defaultMessage: "Select team to add measurement area",
            description: "CreateSubTeamModal header title select team",
          }),
        })}
      />
      <KPICreateSubTeamStack.Screen
        name="KPICreateSubTeamSetName"
        component={KPICreateSubTeamSetName}
        options={{
          headerBackTitle: intl_tokens.Back,
          title: intl.formatMessage({
            defaultMessage: "Add measurement area",
            description: "CreateSubTeamModal header title add measurement area",
          }),
        }}
      />
    </KPICreateSubTeamStack.Navigator>
  );
}
